






































import { Vue, Component } from "vue-property-decorator";

interface ResetPasswordDialogArgs {
  title: string;
  message: string;
  acceptMessage?: string | null;
  rejectMessage?: string | null;
  compact?: boolean;
  cancelable?: boolean;
}

@Component
export default class ResetPasswordDialogComponent extends Vue {
  isShowing = false;

  title = "";
  message = "";

  readonly = false;
  temporaryPasswordError: Array<string> = [];
  temporaryPassword = "";

  acceptMessage = "";
  rejectMessage = "";

  showNegativeButton = true;
  showPositiveButton = true;
  showCompact = false;

  resolve?: (value: string) => void = undefined;
  reject?: (reason: string) => void = undefined;

  cancelable = true;

  async show(args: ResetPasswordDialogArgs) {
    const {
      title,
      message,
      acceptMessage,
      rejectMessage,
      compact,
      cancelable,
    } = args;

    this.temporaryPassword = "";
    this.temporaryPasswordError = [];

    this.showCompact = compact ? true : false;
    this.cancelable = cancelable ?? true;

    this.title = title;
    this.message = message;

    this.showNegativeButton = rejectMessage !== null;
    this.showPositiveButton = acceptMessage !== null;

    this.acceptMessage = acceptMessage
      ? acceptMessage
      : this.$t("common.yes").toString();
    this.rejectMessage = rejectMessage
      ? rejectMessage
      : this.$t("common.abort").toString();

    this.isShowing = true;

    return new Promise<string>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  onAccept() {
    if (this.temporaryPassword.length < 8) {
      this.temporaryPasswordError = [
        this.$t("users.error.passwordToShort").toString(),
      ];
    } else {
      this.isShowing = false;
      this.resolve && this.resolve(this.temporaryPassword);
    }
  }

  onReject() {
    this.isShowing = false;
    this.resolve && this.resolve("");
  }

  onInput() {
    this.resolve && this.resolve(this.temporaryPassword);
  }
}
